/* eslint-disable */
import React, { Component, Suspense } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import MetaTags from "../MetaTags";
import Waiting from '../Waiting';
const TopBarPopup = React.lazy(() => import('../TopBarPopUp'));

const LayoutContainer = styled.div`
    display: block;
    position: relative;
    width: 100%;
    height: auto;
    overflow: hidden;
    margin: 0px auto
`;

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTopBarPopupVisible: false,
    };
  }

  componentDidMount() {
    this.top && this.top.scrollIntoView({block: "start"});
    const portalPath = [
      "about",
      "privacy-policy",
      "terms-use",
      "thankyou",
      "why-woliba",
      "employee-engagement",
      "corporate-wellness",
      "wellness-education",
      "nutrition-recipes",
      "fitness-videos",
      "activity-challenges",
      "wellness-challenges",
      "wellness-admin",
      "pricing",
      "contact",
      "wellness-events",
      "employee-recognition",
      "employee-rewards"
    ];
      if(portalPath.includes(window.location.pathname.split("/")[1])|| !window.location.pathname.split("/")[1]){
      this.props.history.push("/portal")
    }
    if (portalPath.includes(window.location.pathname.split("/")[1]) || !window.location.pathname.split("/")[1]) {
      (function (h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        h._hjSettings = { hjid: 3425271, hjsv: 6 };
        a = o.getElementsByTagName("head")[0];
        r = o.createElement("script");
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
      this.setState({isTopBarPopupVisible : true});
    }

    if (portalPath.includes(window.location.pathname.split("/")[1]) || !window.location.pathname.split("/")[1]) {

            // Create a script element
            const scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.id = 'vwoCode';
            scriptElement.innerHTML = `
              window._vwo_code || (function() {
                var account_id=816869,
                version=2.0,
                settings_tolerance=2000,
                hide_element='body',
                hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
                /* DO NOT EDIT BELOW THIS LINE */
                f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();
              })();
            `;
      
            // Append the script element to the document body
            document.body.appendChild(scriptElement);
    }
    this.top && this.top.scrollIntoView({block: "start"});
  }

  componentWillUnmount(){
    // Clean up when the component is unmounted
    const scriptElement = document.getElementById('vwoCode');
    if (scriptElement) {
      document.body.removeChild(scriptElement);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    window.scrollTo(0, this.top && this.top.offsetTop)
  }

  render() {
    return (
      <LayoutContainer>
        <MetaTags history={this.props.history} />
        <div ref={(node) => this.top = node }>
           {this.state.isTopBarPopupVisible && <Suspense fallback={<Waiting/>}><TopBarPopup history={this.props.history}/></Suspense>}
          {this.props.children}
        </div>
      </LayoutContainer>
    )
  }
}

Layout.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(Layout);